import React from 'react';
import * as Styles from '../Resources.styles';
import { IconArrow } from 'gatorcomponents';
import IconCamera from '../media/iconCamera';

const CardResourceImage = ({ element }) => (
  <Styles.CardResourceImage data-testid={`card-resource-image-${element.title.replace(/\s+/g, '-').toLowerCase()}`} backgroundImg={element.image} onClick={element.cta.onClick} size={element.size}>
    <Styles.DivContent>
      <Styles.Title dangerouslySetInnerHTML={{ __html: element.title }} />
      <Styles.DescriptionBox>
        <IconCamera />
        <Styles.Description dangerouslySetInnerHTML={{ __html: element.description }} />
      </Styles.DescriptionBox>
    </Styles.DivContent>

    <Styles.ArrowBox>
      <IconArrow direction="top" size="md" color="highPure" />
    </Styles.ArrowBox>
  </Styles.CardResourceImage>
);

export default CardResourceImage;
